if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.targetDate = new Date(this.dataset.targetDate).getTime();
      if (isNaN(this.targetDate)) return;

      this.valueEls = {
        days: this.querySelector('[data-countdown-value="days"]'),
        hours: this.querySelector('[data-countdown-value="hours"]'),
        minutes: this.querySelector('[data-countdown-value="minutes"]'),
        seconds: this.querySelector('[data-countdown-value="seconds"]'),
      };

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      const remaining = Math.max(0, this.targetDate - Date.now());

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      this.setValue('days', days);
      this.setValue('hours', hours);
      this.setValue('minutes', minutes);
      this.setValue('seconds', seconds);

      if (remaining <= 0) {
        clearInterval(this.interval);
        this.classList.add('is-finished');
        this.dispatchEvent(new CustomEvent('countdown:finished', { bubbles: true }));
      }
    }

    setValue(unit, value) {
      const el = this.valueEls[unit];
      if (el) el.textContent = String(value).padStart(2, '0');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
